import { put, call, takeLatest, select } from "redux-saga/effects";
import * as Api from "../api";
import * as ActionConstants from "../actions/actionConstants";
import {status as filterStatus} from "../Notification/constants";
import {LOG_APPLICATON_ERROR} from "../../../containers/WorkkardDetail/actions/actionConstants";
import {  ErrorCode } from '../../../containers/WorkkardDetail/constants';

export function* notificationUpdateCall(payload,extraData,skipStatusUpdate){
    try{
        if (payload.isOnNotificationDetail){
            let workkardId=null;
            if(extraData["workkardId"] != undefined)
            {
                workkardId = extraData["workkardId"]
            }
            else{
                const getItems = (state) => (state.workkardDetail.workkardDetail);
                const items = yield select(getItems);
                workkardId =  items.Id;
            }
            delete payload.isOnNotificationDetail;
            const param ={payload:Object.assign({},payload,{wkId:workkardId, status : payload.status ? payload.status:filterStatus.unRead})};
            yield *fetchNotificationDetailData(param,skipStatusUpdate)
        } else {
            delete payload.isOnNotificationDetail;
            let apiData={};
            apiData=extraData["Data"] != undefined ? Object.assign({}, payload, {status : extraData.Data}) : payload;
            apiData=payload["isGroupByEnabled"] != undefined ? apiData : Object.assign({}, apiData, {isGroupByEnabled: extraData.IsGroupByEnabled});
            // const data =yield call(Api.getUpdates,ActionConstants.FETCH_NOTIFICATION_LATEST_UPDATE_DATA_REQUEST,apiData);
            const data =yield call(Api.getNotificationData,apiData);
            yield put ({
                type: ActionConstants.FETCH_NOTIFICATION_DATA_SUCCESS,
                payload: { data: data, panelFilterSettings: extraData , sortOrder:payload.sortOrder}
            })
            if(!skipStatusUpdate){
                yield call(Api.updateNotificationStatus, { workkard_id: 0, status: filterStatus.unRead });
            }
        }
    }
    catch(error){
        console.log(error)
    }
}

export function* getAUCounts({payload}){
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        const response =yield call(Api.getAUCounts,ActionConstants.GET_AU_COUNT_REQUEST,payload);

        if(response.status==200){
            yield put ({
                type: ActionConstants.GET_AU_COUNT_SUCESS,
                payload: response
            })
        }
        else if(response.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:response.status, isErrorScreen:false}
            });
        }    
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
} 

export function* fetchNotificationData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        // /userprofile/getactivityupdatepanelfiltersetting disabled for now
        // const panelFilterSettings =yield call(Api.getPanelFilterSettings,ActionConstants.FETCH_NOTIFICATION_PANEL_SETTING_DATA_REQUEST,{_: new Date()});
        const panelFilterSettings = { status: 200, IsGroupByEnabled: true };

        if(panelFilterSettings.status==200){
            const newPanelFilterSettings = payload.isOnNotificationDetail ? Object.assign({},panelFilterSettings,{IsGroupByEnabled: false}):panelFilterSettings;
            if(payload.isOnNotificationDetail){
                yield put({
                    type: ActionConstants.UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS,
                    payload: { filterStatus: filterStatus.unRead }
                })
            }
            yield* notificationUpdateCall(payload, newPanelFilterSettings, payload.skipStatusUpdate);
        }
        else if(panelFilterSettings.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:panelFilterSettings.status , isErrorScreen:true}
            });
        }    
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
}

export function* fetchFilterNotificationData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        // /userprofile/updateactivityupdatepanelfiltersetting disabled for now
        // const panelFilterSettings =yield call(Api.updatePanelFilterSettings,ActionConstants.UPDATE_NOTIFICATION_PANEL_SETTING_DATA_REQUEST,{filterStatus:payload.status});
        const panelFilterSettings = { status: 200 };

        if(panelFilterSettings.status==200){
            yield put({
                type:ActionConstants.UPDATE_NOTIFICATION_PANEL_SETTING_DATA_SUCCESS,
                payload:{filterStatus:payload.status}
            })
            const getItems = (state) => state.header.notification;
            const items = yield select(getItems);
            let workkardId=null;
            if (payload.isOnNotificationDetail){
                workkardId=items.notificationDetail.WorkkardId
            }
            yield *notificationUpdateCall(payload,{IsGroupByEnabled:items.panelFilterSettings.IsGroupByEnabled,workkardId:workkardId},true);
        }
        else if(panelFilterSettings.status ==  ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:panelFilterSettings.status, isErrorScreen:true}
            });
        }    
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
}

export function* updateNotificationData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        if (payload.isOnNotificationDetail) {
            delete payload.isOnNotificationDetail;
            // const response =yield call(Api.getWorkkardUpdates,ActionConstants.FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,payload);
            const response =yield call(Api.getNotificationData,payload);
            yield put ({
                type: ActionConstants.UPDATE_NOTIFICATION_DETAIL_DATA_SUCCESS,
                payload:response
            })
        }
        else{
            delete payload.isOnNotificationDetail;
            // const latestUpdates =yield call(Api.getOlderUpdates,ActionConstants.UPDATE_NOTIFICATION_DATA_REQUEST,payload);
            const latestUpdates =yield call(Api.getNotificationData,payload);
            yield put ({
                type: ActionConstants.UPDATE_NOTIFICATION_DATA_SUCCESS,
                payload:latestUpdates 
            })
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
}

export function* changeGroupUpdates({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        const notificationId=payload.Id;
        const markAllAsRead = payload['markAllAsRead'];
        delete payload.markAllAsRead;
        delete payload.Id;
        
        // const response =yield call(Api.changeGroupUpdatesApi,ActionConstants.CHANGE_GROUP_UPDATES_REQUEST,payload);
        const apiPayload = { workkard_id: payload.wkId, status: payload.status };
        if(markAllAsRead != undefined){
            apiPayload.updated = true;
        }
        const response =yield call(Api.updateNotificationStatus,apiPayload);
        if(response){
            yield put ({
                type: ActionConstants.CHANGE_GROUP_UPDATES_SUCCESS,
                payload:response.UnreadNotificationCount ?? 0
            })
            if(payload.wkId > 0 && payload.status == filterStatus.read){
                yield* updateWorkkardAUStatus(payload.wkId);
            }
            // /resetwkdgrpcounter disabled for now
            // const resetResponse = yield call(Api.resetWorkkardGroupCounter, ActionConstants.RESET_WORKKARD_GROUP_COUNTER_REQUEST, payload);
            if(markAllAsRead==undefined){
                yield put ({
                    type: ActionConstants.RESET_WORKKARD_GROUP_SUCCESS,
                    payload: { wkId: payload.wkId, notificationId: notificationId, fltStatus: payload.status, UnreadNotificationCount: response.UnreadNotificationCount ?? 0 }
                })
            }
            else{
                if(markAllAsRead){
                    yield put ({
                        type: ActionConstants.MARK_ALL_READ,
                        payload: { allFilterStatus: payload.status, allUpdates: payload.allUpdates || false}
                    })
                }
                else{
                    yield put ({
                        type: ActionConstants.MARK_ALL_GROUP_READ,
                        payload:{grpfilterStatus:payload.status , grpwkId:payload.wkId}
                    })
                }
            }
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:500, isErrorScreen:false }
            });
        }
    }
        catch(error){

        }
        finally{
            yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
        }
    }
    
export function* filterGroupByData({payload}) {
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        // /resetwkdgrpcounter and /updategrpwkdsetting disabled for now
        // if(payload.isGroupByEnabled){
        //     yield call(Api.resetWorkkardGroupCounter,ActionConstants.RESET_WORKKARD_GROUP_COUNTER_REQUEST,{wkId:0,resetAllCounters:true});
        // }
        // yield call(Api.updateGroupWorkkardSetting,ActionConstants.FETCH_FILTER_GROUP_BY_DATA_REQUEST,{groupByWorkkard:payload.isGroupByEnabled});
        yield put({
            type: ActionConstants.RESET_NOTIFICATION_DATA_SUCCESS
        })
        yield* notificationUpdateCall(payload, { IsGroupByEnabled: payload.isGroupByEnabled }, true);
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
}

export function* changeActivityUpdatesStatus({payload}) {
    try{
        if (!payload.resetCounter){
            yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        }
        // const {status} =yield call(Api.changeActivityUpdatesStatus,ActionConstants.CHANGE_ACTIVITY_UPDATES_REQUEST,payload);
        const response =yield call(Api.updateNotificationStatus,{ ids: [payload.activityUpdateIds], status: payload.status });

        if(response){
            yield put ({ type: ActionConstants.CHANGE_ACTIVITY_UPDATES_SUCCESS, payload:payload })
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status:500, isErrorScreen:false }
            });
        }
    }
    catch(error){ }
    finally {
        if (!payload.resetCounter) {
            yield put({ type: ActionConstants.HIDE_HEADER_LOADER }); 
        }
    }
}

export function* fetchNotificationDetailData({payload},skipStatusUpdate){
    try{
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        let updatesResponse = { status: 200 };
        if(!skipStatusUpdate){
            updatesResponse = yield call(Api.updateNotificationStatus, { workkard_id: 0, status: filterStatus.unRead });
        }
        if(updatesResponse && updatesResponse.status==200){
            const auStatus = yield* updateWorkkardAUStatus(payload.wkId);
            // /resetwkdgrpcounter disabled for now
            // yield call(Api.resetWorkkardGroupCounter, ActionConstants.RESET_WORKKARD_GROUP_COUNTER_REQUEST, { wkId: payload.wkId });
            if(auStatus.status==200){
                // const response =yield call(Api.getWorkkardUpdates,ActionConstants.FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,payload);
                const response =yield call(Api.getNotificationData,payload);
                if(response.status==200){
                    yield put ({
                        type: ActionConstants.FETCH_NOTIFICATION_DETAIL_DATA_SUCCESS,
                        payload:Object.assign({},response ,{UnreadNotificationCount: auStatus.UnreadNotificationCount,sortOrder:payload.sortOrder})
                    })
                    yield put ({
                        type:ActionConstants.RESET_GROUPING_DATA
                    })
                }
                else if(response.status ==  ErrorCode.RedirectToLogout){
                    yield* logout();
                } else {
                    yield put({
                    type: LOG_APPLICATON_ERROR,
                    payload: { status:response.status, isErrorScreen:false }
                    });
                }
            }
        }
        else if(updatesResponse && updatesResponse.status == ErrorCode.RedirectToLogout){
            yield* logout();
        } else {
            yield put({
            type: LOG_APPLICATON_ERROR,
            payload: { status: updatesResponse ? updatesResponse.status : 500, isErrorScreen:false }
            });
        }
    }
    catch(error){

    }
    finally{
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
    }
}

export function* getNewNotificationCount({payload}) {
    try {
        const getItems = (state) => (state.header.notification);
        const items = yield select(getItems);
        if (items.notificationDetail && items.notificationDetail.Data && items.notificationDetail.Data.length && items.notificationDetail.WorkkardId == payload.workkardId && items.filter.filterStatus != filterStatus.read){
            yield put({ type: ActionConstants.UPDATE_NEW_NOTIFICATION_DETAIL_DATA, payload: {Data : payload} })
        } else {
            let newUpdatesCount = parseInt(payload.allNotificationCount);
            yield put({ type: ActionConstants.UPDATE_NOTIFICATION_COUNTER, payload: newUpdatesCount })
        }
    }
    catch (error) { }
    finally { }
} 

export function* handleSorting({payload}){
    try {
        yield put({ type: ActionConstants.SHOW_HEADER_LOADER });
        if(payload.isOnNotificationDetail){
            delete payload.isGroupByEnabled;
            yield* notificationUpdateCall(payload,{workkardId:payload.wkId},true);
        }
        else{
            delete payload.wkId;
            yield* notificationUpdateCall(payload,{},true);
        }
    }
    catch (error) { }
    finally {
        yield put({ type: ActionConstants.HIDE_HEADER_LOADER });
     }
}

export function* updateRecentWorkkardNotifStatus(){
    try {
        // /activityupdate/UpdateRecentNotificationStatus disabled for now
        // yield call(Api.updateRecentWorkkardNotifStatus, ActionConstants.UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST);
    }
    catch (error) { }
    finally { }
}

export function* updateWorkkardAUStatus(id){
    try {
        // /wkdaustatus disabled for now
        // return yield call(Api.getWorkkardAuStatus,ActionConstants.GET_WORKKARD_AU_STATUS_REQUEST,{wkId: id,_: new Date()});
        return { status: 200, UnreadNotificationCount: 0 };
    }
    catch (error) { }
    finally { }
}

export default [
    takeLatest(ActionConstants.FETCH_NOTIFICATION_DATA_REQUEST, fetchNotificationData),
    takeLatest(ActionConstants.FETCH_FILTER_NOTIFICATION_DATA_REQUEST, fetchFilterNotificationData),
    takeLatest(ActionConstants.UPDATE_NOTIFICATION_DATA_REQUEST, updateNotificationData),
    takeLatest(ActionConstants.CHANGE_GROUP_UPDATES_REQUEST,changeGroupUpdates),
    takeLatest(ActionConstants.FETCH_FILTER_GROUP_BY_DATA_REQUEST, filterGroupByData),
    takeLatest(ActionConstants.CHANGE_ACTIVITY_UPDATES_REQUEST,changeActivityUpdatesStatus),
    takeLatest(ActionConstants.FETCH_NOTIFICATION_DETAIL_DATA_REQUEST,fetchNotificationDetailData),
    takeLatest(ActionConstants.GET_AU_COUNT_REQUEST,getAUCounts),
    takeLatest(ActionConstants.NEW_NOTIFICATION_REQUEST, getNewNotificationCount),
    takeLatest(ActionConstants.NOTIFICATION_SORTING_REQUEST,handleSorting),
    takeLatest(ActionConstants.UPDATE_RECENT_NOTIFICATION_STATUS_REQUEST,updateRecentWorkkardNotifStatus),
];